/**
 * 
 * 
 * 
 * @modify date 2020-09-16 11:10
 */

export const fields = {
    columns: {
        eeee: null,
        description: null,
        published: false,
    }
}
